
import {Popup, Cell, CellGroup, Slider} from 'vant'
import {checkBrowser, getTime, transform} from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Slider.name]: Slider,
  },
  data () {
    return {
      aaa: 111,
    }
  },
  methods: {
    test () {
    },
  },
  mounted () {
    let url = `http://wx-server.spreadwin.cn/services/frontpage/html/tuyunDownload/tuyunDownloadAll.html?v=v2`;
    console.log(`途云下载url: ${url}`);
    return window.location.replace(url);
  },
  destroyed () {
  }
}
